import { render, staticRenderFns } from "./BotCreateModal.vue?vue&type=template&id=45bb1b09"
import script from "./BotCreateModal.vue?vue&type=script&lang=ts"
export * from "./BotCreateModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports